import backend from 'network/BackendFetchAdapter';

import { ZipCodes } from 'lib/type/zipCode';

export const zipCodeApi = {
  searchZipCode: (search: string): Promise<ZipCodes[]> => backend.fetchJson(`/api/public/zip-codes?search=${search}`),
  listZipCodes: (zipCodes: string): Promise<ZipCodes[]> => backend.fetchJson(`/api/public/zip-codes/list?zipCodes=${zipCodes}`),

};
